// extracted by mini-css-extract-plugin
module.exports = {"label":"BottomTabBar_label__2Ponj"};